import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);

function initialLang() {
  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get("lang");
  if (urlLang === "fr" || urlLang === "en") return urlLang;
  return localStorage.getItem("rst_lang") || "fr";
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(initialLang);

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("rst_lang", l);
    document.documentElement.lang = l;
    const url = new URL(window.location.href);
    if (l === "fr") url.searchParams.delete("lang");
    else url.searchParams.set("lang", l);
    window.history.replaceState({}, "", url);
  }, []);

  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);

  const L = useCallback(
    (obj, field) => {
      if (!obj) return "";
      const primary = obj[`${field}_${lang}`];
      if (primary) return primary;
      return obj[`${field}_fr`] || obj[`${field}_en`] || "";
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, changeLang, t, L }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
